import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-error--title" }
const _hoisted_2 = { class: "text-bold" }
const _hoisted_3 = {
  key: 0,
  class: "text-italic"
}

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxExternal from "src/components/special/SfxExternal.vue"
import { LABELS } from "src/env/labels"
import { useConfigurationStore } from "src/stores/configurationStore"
import { COMMON_MESSAGES } from "src/util/constants/commonMessages"
import { computed } from "vue"

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogAuthenticationError',
  setup(__props) {

const { dialogRef, onDialogOK } = useDialogPluginComponent()
const configurationStore = useConfigurationStore()
const easterEggsEnabled = computed(() => configurationStore.easterEggs)

//endregion

//region Functions

async function onDialogClose() {
  onDialogOK()
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-center" }, {
            default: _withCtx(() => [
              _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t("sfxDialogAuthentication.title")), 1),
              _createVNode(_component_q_card_section, { class: "text-error--content text-body1" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("sfxDialogAuthentication.text1")), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("sfxDialogAuthentication.text2")), 1),
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogAuthentication.text3")) + " ", 1),
                    _createVNode(SfxExternal, {
                      href: _unref(COMMON_MESSAGES).STATUS_LINK
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogAuthentication.here")), 1)
                      ]),
                      _: 1
                    }, 8, ["href"])
                  ]),
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogAuthentication.text4")) + " ", 1),
                    _createVNode(SfxExternal, {
                      href: _unref(COMMON_MESSAGES).SUPPORT_LINK
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogAuthentication.contact_support", { support: _unref(LABELS).SUPPORT })) + ". ", 1)
                      ]),
                      _: 1
                    }, 8, ["href"])
                  ]),
                  _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("sfxDialogAuthentication.text5")), 1),
                  (easterEggsEnabled.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t("sfxDialogAuthentication.quote")), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(SfxBtn, {
                label: _ctx.$t('sfxButtons.btn_understood'),
                class: "col-grow",
                onClick: onDialogClose
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})